import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Layout } from './components/layout/Layout'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { DashboardPage } from './pages/dashboard/DashboardPage'
import { LeadsListPage } from './pages/leads/LeadsListPage'
import { AccountsListPage } from './pages/accounts/AccountsListPage'
import { ContactsListPage } from './pages/contacts/ContactsListPage'
import { OpportunitiesListPage } from './pages/opportunities/OpportunitiesListPage'
import { EventsListPage } from './pages/events/EventsListPage'
import { NotesListPage } from './pages/notes/NotesListPage'
import { ConciergeListPage } from './pages/concierge/ConciergeListPage'
import { ConciergeDetailPage } from './pages/concierge/ConciergeDetailPage'
import { ConciergePartnersPage } from './pages/concierge/ConciergePartnersPage'
import { LeadDetailPage } from './pages/leads/LeadDetailPage'
import { MailingListExportPage } from './pages/leads/MailingListExportPage'
import { AccountDetailPage } from './pages/accounts/AccountDetailPage'
import { ContactDetailPage } from './pages/contacts/ContactDetailPage'
import { OpportunityDetailPage } from './pages/opportunities/OpportunityDetailPage'
import { EventDetailPage } from './pages/events/EventDetailPage'
import { NoteDetailPage } from './pages/notes/NoteDetailPage'
import { LoginPage } from './pages/auth/LoginPage'
import { RegisterPage } from './pages/auth/RegisterPage'
import { TwoFactorPage } from './pages/auth/TwoFactorPage'
import { OutlookLoginPage } from './pages/auth/OutlookLoginPage'
import { SetupTwoFactorPage } from './pages/auth/SetupTwoFactorPage'
import { UsersListPage } from './pages/users/UsersListPage'
import { SharingRulesPage } from './pages/settings/SharingRulesPage'
import { RecordSharesPage } from './pages/settings/RecordSharesPage'
import { AuditLogPage } from './pages/settings/AuditLogPage'
import { WebsiteConfigsPage } from './pages/settings/WebsiteConfigsPage'
import { ApiKeysPage } from './pages/settings/ApiKeysPage'
import { WebLeadsListPage } from './pages/web-leads/WebLeadsListPage'
import { WebLeadDetailPage } from './pages/web-leads/WebLeadDetailPage'
import { TicketsListPage } from './pages/tickets/TicketsListPage'
import { TicketDetailPage } from './pages/tickets/TicketDetailPage'
import { EmailsListPage } from './pages/emails/EmailsListPage'
import { AssetsListPage } from './pages/assets/AssetsListPage'
import { AssetDetailPage } from './pages/assets/AssetDetailPage'
import { ServiceCasesListPage } from './pages/service-cases/ServiceCasesListPage'
import { ServiceCaseDetailPage } from './pages/service-cases/ServiceCaseDetailPage'
import { ServiceCaseCreatePage } from './pages/service-cases/ServiceCaseCreatePage'
import { TwinProjectsListPage } from './pages/twin/TwinProjectsListPage'
import { TwinProjectDetailPage } from './pages/twin/TwinProjectDetailPage'
import { TwinProjectCreatePage } from './pages/twin/TwinProjectCreatePage'
import { ProductsListPage } from './pages/products/ProductsListPage'
import { ProductDetailPage } from './pages/products/ProductDetailPage'
import { QuotesListPage } from './pages/quotes/QuotesListPage'
import { QuoteDetailPage } from './pages/quotes/QuoteDetailPage'
import { QuoteCreatePage } from './pages/quotes/QuoteCreatePage'
import { OrdersListPage } from './pages/orders/OrdersListPage'
import { OrderDetailPage } from './pages/orders/OrderDetailPage'
import { ApprovalsQueuePage } from './pages/cpq/ApprovalsQueuePage'
import { CpqRulesPage } from './pages/cpq/CpqRulesPage'
import { PDFImportPage } from './pages/cpq/PDFImportPage'
import { ProxyResolutionPage } from './pages/cpq/ProxyResolutionPage'
import SapIntegrationPage from './pages/settings/SapIntegrationPage'
import { CartridgesPage } from './pages/settings/CartridgesPage'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public auth routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-2fa" element={<TwoFactorPage />} />
        <Route path="/outlook-login" element={<OutlookLoginPage />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />

          <Route path="leads">
            <Route index element={<LeadsListPage />} />
            <Route path="mailing-export" element={<MailingListExportPage />} />
            <Route path=":id" element={<LeadDetailPage />} />
          </Route>

          <Route path="accounts">
            <Route index element={<AccountsListPage />} />
            <Route path=":id" element={<AccountDetailPage />} />
          </Route>

          <Route path="contacts">
            <Route index element={<ContactsListPage />} />
            <Route path=":id" element={<ContactDetailPage />} />
          </Route>

          <Route path="opportunities">
            <Route index element={<OpportunitiesListPage />} />
            <Route path=":id" element={<OpportunityDetailPage />} />
          </Route>

          <Route path="events">
            <Route index element={<EventsListPage />} />
            <Route path=":id" element={<EventDetailPage />} />
          </Route>

          <Route path="notes">
            <Route index element={<NotesListPage />} />
            <Route path=":id" element={<NoteDetailPage />} />
          </Route>

          <Route path="concierge">
            <Route index element={<ConciergeListPage />} />
            <Route path=":id" element={<ConciergeDetailPage />} />
            <Route path="partners" element={<ConciergePartnersPage />} />
          </Route>

          <Route path="web-leads">
            <Route index element={<WebLeadsListPage />} />
            <Route path=":id" element={<WebLeadDetailPage />} />
          </Route>

          <Route path="tickets">
            <Route index element={<TicketsListPage />} />
            <Route path=":id" element={<TicketDetailPage />} />
          </Route>

          <Route path="emails" element={<EmailsListPage />} />

          <Route path="assets">
            <Route index element={<AssetsListPage />} />
            <Route path=":id" element={<AssetDetailPage />} />
          </Route>

          <Route path="service-cases">
            <Route index element={<ServiceCasesListPage />} />
            <Route path="new" element={<ServiceCaseCreatePage />} />
            <Route path=":id" element={<ServiceCaseDetailPage />} />
          </Route>

          <Route path="twin">
            <Route index element={<TwinProjectsListPage />} />
            <Route path="new" element={<TwinProjectCreatePage />} />
            <Route path=":id" element={<TwinProjectDetailPage />} />
          </Route>

          <Route path="products">
            <Route index element={<ProductsListPage />} />
            <Route path=":id" element={<ProductDetailPage />} />
          </Route>

          <Route path="quotes">
            <Route index element={<QuotesListPage />} />
            <Route path="new" element={<QuoteCreatePage />} />
            <Route path=":id" element={<QuoteDetailPage />} />
          </Route>

          <Route path="orders">
            <Route index element={<OrdersListPage />} />
            <Route path=":id" element={<OrderDetailPage />} />
          </Route>

          <Route path="approvals" element={<ApprovalsQueuePage />} />

          <Route path="cpq">
            <Route path="pdf-import" element={<PDFImportPage />} />
            <Route path="proxy-products" element={<ProxyResolutionPage />} />
            <Route path="quotes/:id" element={<QuoteDetailPage />} />
          </Route>

          <Route path="settings/2fa" element={<SetupTwoFactorPage />} />
          <Route path="settings/cpq-rules" element={<CpqRulesPage />} />
          <Route path="settings/sharing-rules" element={<SharingRulesPage />} />
          <Route path="settings/record-shares" element={<RecordSharesPage />} />
          <Route path="settings/audit-log" element={<AuditLogPage />} />
          <Route path="settings/website-configs" element={<WebsiteConfigsPage />} />
          <Route path="settings/api-keys" element={<ApiKeysPage />} />
          <Route path="settings/sap-integration" element={<SapIntegrationPage />} />
          <Route path="settings/cartridges" element={<CartridgesPage />} />

          <Route path="users" element={<UsersListPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
